import cleanDeep from "clean-deep";
import { NotificationManager } from "react-notifications";
import { connect } from "react-redux";
import { Actions as COMPANY_ACTIONS } from "../../../store/actions/companyActions";
import { Actions as OVERTIME_ACTIONS } from "../../../store/actions/overtimeActions";

import { CheckCircleIcon, PlusIcon } from "@heroicons/react/20/solid";
import { cloneDeep, orderBy } from "lodash";
import NoItemsRow from "../../common/NoItemsRow";
import AdvancedSettingsModal from "../modals/AdvancedSettingsModal";
import UpdatePeriodTypeModal from "../modals/UpdatePeriodTypeModal";
import OvertimeRow from "./OvertimeRow";

const OvertimeSettings = ({
	overtimes,
	addOvertime,
	updateCompanyDetails,
	currentOrg,
	disabled,
	jurisdiction,
}) => {

	const onSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();

		const invalidOvertimes =
			overtimes?.length > 0 &&
			overtimes?.find((overtime) => !(overtime.name && overtime.rate && overtime.hasOwnProperty("isToil")));

		if (invalidOvertimes)
			return NotificationManager.error("Please ensure all fields are filled before saving!", "Overtime");

		updateCompanyDetails(
			cleanDeep(
				{
					org: String(currentOrg),
					overtimes: overtimes?.map((overtime) => {
						overtime.temporary = undefined;
						return overtime;
					}),
				},
				{ emptyStrings: false, emptyArrays: false, emptyObjects: false },
			),
		);
	};

	return (
		<form
			onSubmit={onSubmit}
			style={{ paddingBottom: 30 }}
            className="px-8"
		>
			<UpdatePeriodTypeModal />
			<AdvancedSettingsModal />
			<div className="form-section col-xs-12">
				<div className="col-xs-12">
					<div className="pull-left">
						<h4>Overtime & Special Rates</h4>
					</div>
					{!disabled && (
						<button
							className="btn btn-success pull-right"
							type="button"
							id="add-overtime-type"
							onClick={() => {
								console.log("Adding Overtime Row");
								addOvertime();
							}}
						>
							<PlusIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
							<div style={{ float: "left" }}>Add Rate</div>
						</button>
					)}
				</div>
				<div className="clearfix" />

				<div className="col-xs-12 pl-0 pb-6">
					{overtimes?.length ? (
						<>
							{overtimes?.map((overtime) => (
								<OvertimeRow
									key={overtime.id}
									overtime={overtime}
								/>
							))}
						</>
					) : (
						<table
							id="table-timesheets"
							className="js-table-sections table table-hover"
						>
							<NoItemsRow name="Overtime or Special Rates" />
						</table>
					)}
				</div>
			</div>

			<div className="col-xs-12 pr-0 text-right">
				{!disabled && (
					<button
						className="btn btn-success"
						type="submit"
					>
						<CheckCircleIcon style={{ height: "1.5em", float: "left" }} />
						<div style={{ float: "left" }}>Save</div>
					</button>
				)}
			</div>
		</form>
	);
};

const mapStateToProps = (state) => {
	const settings = cloneDeep(state.company?.settings);

	if (typeof settings?.showEmployerContributions == "undefined") {
		settings.showEmployerContributions = true;
	}

	return {
		sickPaySchemes: state.company?.settings?.sickPaySchemes,
		jurisdiction: state.company?.settings?.jurisdiction,
		paySchedules: state.company?.settings?.paySchedules,
		allowances: state.company?.settings?.allowances,
		overtimes: state.company?.settings?.overtimes,
		hasDepartments: state.company?.settings?.departments?.length > 0,
		currentOrg: state.company?.settings?.org,
		settings,
		firstYear: orderBy(state.payPeriods?.periods || [], "year", "asc")?.[0]?.year - 1,
		disabled:
			state?.permissions?.my?.permissions?.settings == "Read" || state?.company?.settings?.status == "Archived",
		currency: state.company?.settings?.currency,
	};
};

const mapDispatchToProps = (dispatch) => ({
	updateCompanyDetails: (body) => dispatch(COMPANY_ACTIONS.updateCompanyDetails(body)),
	addOvertime: () => dispatch(OVERTIME_ACTIONS.addOvertime(false)),
});

export default connect(mapStateToProps, mapDispatchToProps)(OvertimeSettings);
